type LygoLogoProps = {
  compact?: boolean;
  dark?: boolean;
  className?: string;
};

export function LygoLogo({ compact = false, dark = false, className = '' }: LygoLogoProps) {
  const dotColor = dark ? 'text-amber-300' : 'text-amber-500';
  const textColor = dark ? 'text-sidebar-foreground' : 'text-foreground';
  const markBg = dark
    ? 'bg-gradient-to-br from-cyan-500 to-teal-400 text-slate-950'
    : 'bg-gradient-to-br from-cyan-700 to-teal-500 text-white';

  if (compact) {
    return (
      <div className={`inline-flex h-9 w-9 items-center justify-center rounded-lg font-heading text-sm font-bold ${markBg} ${className}`}>
        L
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`}>
      <div className={`inline-flex h-9 w-9 items-center justify-center rounded-lg font-heading text-sm font-bold ${markBg}`}>
        L
      </div>
      <div className="inline-flex items-end gap-0.5 leading-none">
        <span className={`font-heading text-xl font-bold tracking-tight ${textColor}`}>lygo</span>
        <span className={`font-heading text-lg font-bold ${dotColor}`}>.it</span>
      </div>
    </div>
  );
}
